<template>
    <div id="main">
        <div v-if="chooseViewport">
            <MobileViewport />
        </div>
        <div v-else>
            <DesktopViewport />
        </div>
    </div>
</template>

<script>
import { isMobile } from '@basitcodeenv/vue3-device-detect'
import DesktopViewport from '@/components/viewport/DesktopViewport.vue'
import MobileViewport from '@/components/viewport/MobileViewport.vue'
import { mapActions, mapMutations } from 'vuex'

export default {
    name: 'App',
    components: {
        DesktopViewport,
        MobileViewport,
    },
    data() {
        return {
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
        }
    },
    methods: {
        ...mapActions([
            'fetchLatestData',
            'fetchHistoryData',
            'fetchTimeSeriesList',
            'fetchGPSPivot',
            'swipeCard',
        ]),
        ...mapMutations(['setSelectedDate']),
        // fetch latest data every minute
        launchUpdateTask() {
            setInterval(() => {
                // console.log('Running update...')
                // only check if it is XX:00, XX:15, XX:30, XX:45
                const now = new Date()
                if (now.getMinutes() % 15 !== 0) return
                this.fetchLatestData()
            }, 60000)
        },
        launchSwipeTask() {
            let flag = 0 // 0: small, 1: medium
            setInterval(() => {
                if (flag === 0) {
                    this.swipeCard({ cardSize: 'small', direction: 'right' })
                    flag = 1
                } else {
                    this.swipeCard({ cardSize: 'medium', direction: 'right' })
                    flag = 0
                }
            }, 5000)
        },
        handleResize() {
            this.windowWidth = window.innerWidth
            this.windowHeight = window.innerHeight
        },
    },
    computed: {
        chooseViewport() {
            return isMobile || this.windowWidth < this.windowHeight
        },
    },
    mounted() {
        document.title = 'mbhoyaw「復興」- 桃園市復興區永續環境學習網'
        this.launchUpdateTask()
        this.launchSwipeTask()
        window.addEventListener('resize', this.handleResize)
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize)
    },
    created() {
        this.fetchLatestData()
    },
}
</script>

<style lang="scss">
@import url('./assets/fonts/fonts.css');
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
}
body {
    margin: 0px;
}
</style>
